import React from 'react';

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import LayoutDefault from '@/pages/layouts/Default';

import Home from '@/pages/Home';
import Projects from '@/pages/Projects';
import About from '@/pages/About';

import Kulturan from '@/pages/projects/kulturan';
import Medifyid from '@/pages/projects/medifyid';
import VCFTools from '@/pages/projects/vcftools';
import Presto from '@/pages/projects/presto';

const routeItems = [
  {
    layout: LayoutDefault,
    key: 'home',
    path: '/home',
    component: Home,
    visible: false,
  },
  {
    layout: LayoutDefault,
    key: 'projects',
    path: '/projects',
    component: Projects,
    visible: false,
  },
  {
    layout: LayoutDefault,
    key: 'about',
    path: '/about',
    component: About,
    visible: false,
  },
  {
    layout: LayoutDefault,
    key: 'Kulturan',
    path: '/kulturan',
    component: Kulturan,
    visible: false,
  },
  {
    layout: LayoutDefault,
    key: 'Medifyid',
    path: '/medifyid',
    component: Medifyid,
    visible: false,
  },
  {
    layout: LayoutDefault,
    key: 'VCF Tools',
    path: '/vcf-tools',
    component: VCFTools,
    visible: false,
  },
  {
    layout: LayoutDefault,
    key: 'Presto',
    path: '/presto',
    component: Presto,
    visible: false,
  },
];

const routes = () => {
  return (
    <Router>
      <Routes>
        <Route key='home' exact path='/' element={<Navigate to='/home' />} />

        {routeItems.map((routeItem) => {
          return (
            <Route
              key={routeItem.key}
              path={routeItem.path}
              element={<routeItem.layout component={routeItem.component} />}
            />
          );
        })}
        {/* <Route path='*' component={PageNotFound} /> */}
      </Routes>
    </Router>
  );
};

export default routes;
